import React from 'react';
import { Link } from 'react-router-dom';
import { AppleIcon } from './Icons';

const IOS_LINK = 'https://apps.apple.com/us/app/ai-vision-objects-identifier/id6752822635';

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-brand">
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '16px' }}>
              <img src="/app-icon.png" alt="AI Vision" style={{ width: '32px', height: '32px', borderRadius: '7px' }} />
              <h3 style={{ margin: 0 }}>AI Vision</h3>
            </div>
            <p style={{ color: 'var(--text-muted)', maxWidth: '320px', fontSize: '0.92rem' }}>
              Point your camera at anything. AI tells you what it is — instantly.
              Powered by Google Gemini AI.
            </p>
            <div style={{ marginTop: '20px' }}>
              <a
                href={IOS_LINK}
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-app-store"
                style={{ padding: '10px 18px', fontSize: '0.88rem' }}
              >
                <AppleIcon size={22} />
                <span className="btn-app-store-text">
                  <small>Download on the</small>
                  <span>App Store</span>
                </span>
              </a>
            </div>
          </div>

          <div>
            <h4 style={{ color: 'var(--text-heading)', marginBottom: '16px', fontSize: '0.85rem', textTransform: 'uppercase', letterSpacing: '0.08em', fontWeight: 600 }}>
              Resources
            </h4>
            <ul className="footer-links">
              <li><Link to="/support">Support Center</Link></li>
              <li><Link to="/privacy">Privacy Policy</Link></li>
              <li><Link to="/terms">Terms of Service</Link></li>
            </ul>
          </div>

          <div>
            <h4 style={{ color: 'var(--text-heading)', marginBottom: '16px', fontSize: '0.85rem', textTransform: 'uppercase', letterSpacing: '0.08em', fontWeight: 600 }}>
              Contact
            </h4>
            <ul className="footer-links">
              <li><a href="mailto:cyborguser2020@gmail.com">cyborguser2020@gmail.com</a></li>
              <li style={{ color: 'var(--text-muted)', fontSize: '0.92rem' }}>Response within 24 hours</li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} AI Vision Team. All rights reserved.</p>
          <p>
            <Link to="/privacy" style={{ color: 'var(--text-muted)', marginRight: '20px' }}>Privacy</Link>
            <Link to="/terms" style={{ color: 'var(--text-muted)' }}>Terms</Link>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
